import { type ReactNode, createContext, useContext, useMemo } from "react";
import type { useCandidateDetails } from "./logics";

type ICandidateDetails = ReturnType<typeof useCandidateDetails>;

type ICandidateDetailsProviderProps = ICandidateDetails & {
  children: ReactNode;
};

const Context = createContext<ICandidateDetails | undefined>(undefined);

export const useCandidateDetailsContext = () => {
  const context = useContext(Context);
  if (context === undefined) {
    throw new Error("useCandidateDetailsContext must be within CandidateDetailsProvider");
  }

  return context;
};

export const CandidateDetailsProvider = ({ children, ...props }: ICandidateDetailsProviderProps) => {
  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  const value = useMemo(
    () => props,
    [
      props.candidate,
      props.updateCandidate,
      props.cancelPatchCandidate,
      props.setCandidate,
      props.reloadCandidate,
      props.loadingPatchCandidate,
      props.candidateChanges,
      props.setCandidateChanges,
      props.candidateChangesIndex,
      props.setCandidateChangesIndex,
      props.cerToOpen,
      props.setCerToOpen,
      props.updateCer,
      props.loadingPostCanditateCer,
      props.openModalAddObjectives,
      props.setOpenModalAddObjectives,
    ]
  );
  return <Context.Provider value={value}>{children}</Context.Provider>;
};
